import type { UsageGroup } from "../types";
import { formatCost, formatCount, formatSeconds, runTypeLabel } from "../utils/format";
import { TABLE, TABLE_WRAPPER, TBODY, TD, TD_NUMBER, TH, TH_NUMBER, THEAD } from "./tableClasses";

export const CostPerRunTable = ({ groups }: { groups: UsageGroup[] }) => {
  if (groups.length === 0) {
    return <p className="text-sm text-zinc-500">No runs in this period.</p>;
  }
  return (
    <div className={TABLE_WRAPPER}>
      <table className={TABLE}>
        <thead className={THEAD}>
          <tr>
            <th className={TH}>Run type</th>
            <th className={TH_NUMBER}>Runs</th>
            <th className={TH_NUMBER}>Total cost</th>
            <th className={TH_NUMBER}>Average</th>
            <th className={TH_NUMBER}>Median</th>
            <th className={TH_NUMBER}>Highest</th>
            <th className={TH_NUMBER}>Agent time</th>
            <th className={TH_NUMBER}>Total time</th>
            <th className={TH_NUMBER}>Tokens in / out</th>
          </tr>
        </thead>
        <tbody className={TBODY}>
          {groups.map((group) => (
            <tr key={`${group.run_type}-${group.mode ?? ""}`}>
              <td className={`${TD} font-medium text-zinc-900`}>
                {runTypeLabel(group.run_type, group.mode)}
              </td>
              <td className={TD_NUMBER}>{group.runs.toLocaleString()}</td>
              <td className={TD_NUMBER}>{formatCost(group.cost_usd)}</td>
              <td className={TD_NUMBER}>{formatCost(group.avg_cost_usd)}</td>
              <td className={TD_NUMBER}>{formatCost(group.median_cost_usd)}</td>
              <td className={TD_NUMBER}>{formatCost(group.max_cost_usd)}</td>
              <td className={TD_NUMBER}>{formatSeconds(group.avg_agent_seconds)}</td>
              <td className={TD_NUMBER}>{formatSeconds(group.avg_total_seconds)}</td>
              <td className={TD_NUMBER}>
                {formatCount(group.input_tokens)} / {formatCount(group.output_tokens)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
